import { render, staticRenderFns } from "./MInput.vue?vue&type=template&id=2ac4080a"
import script from "./MInput.vue?vue&type=script&lang=js"
export * from "./MInput.vue?vue&type=script&lang=js"
import style0 from "./MInput.vue?vue&type=style&index=0&id=2ac4080a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports